import React from 'react'

import ChavesCertificadoFormPageContainer from './ChavesCertificadoFormPageContainer'

export class ChavesCertificadoFormPage extends React.Component{


    render(){
        return (
           <ChavesCertificadoFormPageContainer {...this.props} />
        )
    }
}
